import ComparisonPage, { CompetitorData } from "@/components/marketing/ComparisonPage";

const competitor: CompetitorData = {
  name: "Zenchef",
  slug: "zenchef",
  type: "Solution internationale complète",
  hasCommissionPerCover: false,
  hasPriceCeiling: false,
  complexity: "moyenne",
  targetAudience: "Restaurants moyens à grands",
  focus: "Gestion + Marketing + Fidélisation",
  supportLanguage: "Français, Anglais, Allemand",
  startingPriceChf: 125,
  commissionPerCoverChf: "Aucune (modèle par abonnement)",
  countryOfOrigin: "France",
  websiteUrl: "https://www.zenchef.com",
  whenToChoose: [
    "Tu gères un restaurant de taille moyenne à grande avec des besoins marketing importants",
    "Tu souhaites des outils avancés de fidélisation client (CRM, campagnes email)",
    "Tu as un budget conséquent",
    "Tu recherches une solution tout-en-un avec création de site web intégrée",
    "Tu gères un groupe de restaurants avec des besoins multi-établissements",
  ],
  pricingDescription:
    "Zenchef affiche publiquement un tarif de départ d'environ 129 EUR/mois (soit ~125 CHF) pour le plan 'Reserve' avec les fonctionnalités de base (widget, Google Reserve). Les plans supérieurs (Engage, Grow) ajoutent le CRM, les campagnes email et l'analytics avancé. Pas de commission par couvert, mais un abonnement mensuel environ 2,5 à 4 fois plus élevé que Piktable. Tarifs détaillés et essai gratuit à confirmer directement auprès de Zenchef.",
  conclusionStrength:
    "les restaurants de taille moyenne à grande qui souhaitent une solution complète avec des outils marketing et de fidélisation intégrés",
  // Discovered, not indexed (GSC) — title accentue le différentiel prix concret
  // (Zenchef ~125 CHF vs Piktable ~3-4× moins cher) pour booster click-through.
  seoTitle: "Zenchef vs Piktable : payer 125 CHF/mois ou 3× moins ?",
  seoDescription: "Zenchef propose une solution complète à partir de ~125 CHF/mois, Piktable couvre les besoins essentiels pour 3 à 4× moins cher. Comparatif détaillé : fonctionnalités, support, ROI pour restaurant suisse.",
};

const PiktableVsZenchef = () => {
  return <ComparisonPage competitor={competitor} />;
};

export default PiktableVsZenchef;
